import { useEffect, useState } from "react";
import { EVENT_DATE } from "@/lib/constants";

function diff() {
  const now = new Date();
  let d = Math.max(0, EVENT_DATE - now);
  const days = Math.floor(d / 86400000);
  d -= days * 86400000;
  const hours = Math.floor(d / 3600000);
  d -= hours * 3600000;
  const minutes = Math.floor(d / 60000);
  d -= minutes * 60000;
  const seconds = Math.floor(d / 1000);
  return { days, hours, minutes, seconds };
}

const Cell = ({ value, label }) => (
  <div className="glass-chroma rounded-lg px-3 py-3 md:px-5 md:py-4 text-center min-w-[64px] md:min-w-[92px]">
    <div className="font-display text-3xl md:text-5xl text-[#00f0ff] leading-none tabular-nums">
      {String(value).padStart(2, "0")}
    </div>
    <div className="font-mono2 text-[9px] md:text-[10px] tracking-[0.25em] text-white/60 mt-1 uppercase">
      {label}
    </div>
  </div>
);

export default function Countdown({ compact = false }) {
  const [t, setT] = useState(diff());
  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div data-testid="countdown-timer" className={`flex gap-2 md:gap-4 ${compact ? "" : "justify-center"}`}>
      <Cell value={t.days} label="Days" />
      <Cell value={t.hours} label="Hrs" />
      <Cell value={t.minutes} label="Min" />
      <Cell value={t.seconds} label="Sec" />
    </div>
  );
}
